import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import GameAbstract from '../core/GameAbstract';
import Template from 'frontools/data/Template';
import { autobind } from 'frontools/decorators/Autobind';
import { Assets } from '../core/Assets';
import NumberUtils from 'frontools/utils/NumberUtils';
import { GameMode, GameManager } from '../core/GameManager';
import GameTimer from '../core/components/GameTimer';
import Context from 'frontools/core/Context';

export class Poussepython extends GameAbstract {

    public static instance      : Poussepython;

    public static CLICK                     : string                        = 'click';
    public static TAP                       : string                        = 'tap';
    private _levelWrapper                   : PIXI.Container                          = new PIXI.Container;

    private _buttonsContainer               : PIXI.Container;
    private _buttonRight                    : PIXI.Container;
    private _buttonLeft                     : PIXI.Container;

    private _snake                          : PIXI.extras.AnimatedSprite;
    private _snakeFace                      : PIXI.extras.AnimatedSprite;
    private _vase                           : PIXI.extras.AnimatedSprite;
    private _vaseBehind                     : PIXI.extras.AnimatedSprite;
    private _mask                           : PIXI.Graphics;
    private _snakeContainer                 : PIXI.Container;
    private _snakeVaseContainer             : PIXI.Container;

    private _note                           : PIXI.extras.AnimatedSprite;
    private _failNote                       : PIXI.extras.AnimatedSprite;
    private _ruler                          : PIXI.extras.AnimatedSprite;

    private _snakeX                         : number                       = 3;

    private _instructionContainer           : PIXI.Container;
    private _instructions                   : {};
    private _currentInstruction             : string;

    constructor() {
        super({
            time: 20,   
            countdown: 1,   
            results: [
                '0-100', //Bas      
                '101-160', //Moyen
                '161-9999' //Élevé  
            ],
            assets: [
                { name: 'left', url: 'sprite/left.png'},
                { name: 'right', url: 'sprite/right.png'},
                { name: 'not-right', url: 'sprite/not-right.png'},
                { name: 'not-left', url: 'sprite/not-left.png'},

                { name: 'snake', url: 'sprite/snake/snake.png'},
                { name: 'snake-face', url: 'sprite/snake/snake-face.json'},
                { name: 'vase', url: 'sprite/vase.png'},
                { name: 'vase-behind', url: 'sprite/vaseBehind.png'},

                { name: 'note', url: 'sprite/note.png'},
                { name: 'fail-note', url: 'sprite/failnote.png'},

                { name: 'ruler', url: 'sprite/ruler.png'},

                { name: 'python', url: 'audio/loop.mp3' },

                { name: 'success1', url: 'audio/success/success1.mp3' },
                { name: 'success2', url: 'audio/success/success2.mp3' },
                { name: 'success3', url: 'audio/success/success3.mp3' },
                { name: 'success4', url: 'audio/success/success4.mp3' },
                
                { name: 'fail1', url: 'audio/fail/fail1.mp3' },
                { name: 'fail2', url: 'audio/fail/fail2.mp3' },
                { name: 'fail3', url: 'audio/fail/fail3.mp3' }
            ]
            
        });

        // Pseudo singleton
        Poussepython.instance = this;
    };


    /*
     * @core override
     * _onPreloadComplete - Called when the preload has been completed
     * 
     */
    protected _onPreloadComplete() {
        super._onPreloadComplete();

        this._snake = Assets.sprites['snake'];
        this._snakeFace = Assets.sprites['snake-face'];
        
        this._vase = Assets.sprites['vase'];
        this._vaseBehind = Assets.sprites['vase-behind'];
        this._mask = this._drawRect(this._screenWidth, this._screenHeight - this._vase.height, 0xFFFFFF, 1);  
        this._mask.isMask = true;

        this._snake.mask = this._mask;
        this._snakeContainer = new PIXI.Container();
        this._snakeVaseContainer = new PIXI.Container();
        this._snakeVaseContainer.addChild(this._vaseBehind);
        this._snakeContainer.addChild(this._snake);
        this._snakeContainer.addChild(this._snakeFace);
        this._snakeVaseContainer.addChild(this._snakeContainer);
        this._snakeVaseContainer.addChild(this._vase);        

        this._instructions = ['left', 'right'];
        this._instructionContainer = new PIXI.Container();
        this._currentInstruction = this._instructions[Math.floor(Math.random() * Object.keys(this._instructions).length)];

        this._instructionContainer.addChild(Assets.sprites[this._currentInstruction]);
        this._instructionContainer.width = 142;
        this._instructionContainer.height = 102;
        this._instructionContainer.alpha = 0;

        this._note = Assets.sprites['note'];
        this._failNote = Assets.sprites['fail-note'];
        this._ruler = Assets.sprites['ruler'];
        this._note.alpha = this._failNote.alpha = 0;

        this._buttonLeft = this.createButton('left');           
        this._buttonRight = this.createButton('right');
        this._buttonsContainer = new PIXI.Container();
        this._buttonsContainer.addChild(this._buttonLeft);
        this._buttonsContainer.addChild(this._buttonRight);

        window.addEventListener('keyup', this._onKeyPress);
    };

    /*
     * @core override
     * _prepare - Prepare the game components and then starts the countdown
     * 
     */    
    protected _prepare() {        
        this._stage.addChild(this._ruler);
        this._stage.addChild(this._snakeVaseContainer);
        this._stage.addChild(this._note);
        this._stage.addChild(this._failNote);
        this._stage.addChild(this._instructionContainer);

        this._stage.addChild(this._buttonsContainer);

        // Trigger components positioning
        // Note: This will initialise core game components and start the countdown
        super._prepare(); 

        this._gameTimer.addListener(GameTimer.TIME_CHANGE, function(e) {
            if (e.progress >= 0.5) this._instructions = ['left', 'right', 'not-left', 'not-right'];
            if (e.progress >= 0.95) clearTimeout(this._generatedTimeOut);
            this._timeProgress = e.progress;
        }.bind(this))
    };

    private _onClick(e) {
        TweenMax.fromTo(e.target, 0.4, {alpha: 0.08}, {alpha: 0});   
        if (this._currentInstruction === 'left' || this._currentInstruction === 'not-right') {
            (e.target.name == "left") ? this._scored("left") : this._failed("right");
        } else if (this._currentInstruction === 'right' || this._currentInstruction === 'not-left') {
            (e.target.name == "right") ? this._scored("right") : this._failed("left");
        }
    }

    @autobind   
    private _onKeyPress(e) { 
        if (this._currentInstruction === 'left' || this._currentInstruction === 'not-right') {
            if (e.keyCode == 37) {
                this._scored("left");
            } else if (e.keyCode == 39) {
                this._failed("right");
            }
        } else if (this._currentInstruction === 'right' || this._currentInstruction === 'not-left') {
            if (e.keyCode == 39) {
                this._scored("right");
            } else if (e.keyCode == 37) {
                this._failed("left");
            }
        }
    }

    @autobind
    private _scored(sideClicked: string) {
        this._gameScore.add(5);

        let sound = Math.floor(Math.random() * 4) + 1;
        Assets.sounds['success' + sound.toString()].play();

        TweenMax.fromTo(this._instructionContainer, 0.1, {alpha: 1}, {alpha: 0, onComplete: this._createInstruction });
        
        this._noteAnimation(this._note, sideClicked);

        if (this._snakeContainer.y > -220) this._snakeAnimation(1);        
    }

    @autobind
    private _failed(sideClicked: string) {
        this._gameScore.remove(3);

        let sound = Math.floor(Math.random() * 3) + 1;
        Assets.sounds['fail' + sound.toString()].play();

        this._noteAnimation(this._failNote, sideClicked);

        this._snakeFace.play();
        this._snakeFace.onFrameChange = function(e) {
           if (e >= this._snakeFace.totalFrames - 1) { this._snakeFace.stop(); }
        }.bind(this);

        if (this._snakeContainer.y < (this._vase.y - 50)) this._snakeAnimation(-1);
    }

    @autobind _createInstruction() {
        this._instructionContainer.removeChild(Assets.sprites[this._currentInstruction])
        this._currentInstruction = this._instructions[Math.floor(Math.random() * Object.keys(this._instructions).length)]; 
        this._instructionContainer.addChild(Assets.sprites[this._currentInstruction]);
        TweenMax.fromTo(this._instructionContainer, 0.2, {alpha: 0}, {alpha: 1});
    }

    @autobind
    private _snakeAnimation(status: number) {
        if (this._snakeContainer.x > 20 && (this._snakeContainer.x + this._snakeContainer.width) < (this._vase.width - 20)) {
            TweenMax.to(this._snakeContainer, 0.2, {y: (this._snakeContainer.y - (5 * status)), x: (this._snakeContainer.x - this._snakeX), onComplete: function() {
                this._snakeX = -this._snakeX;
                TweenMax.to(this._snakeContainer, 0.2, {x: (this._snakeContainer.x - this._snakeX)});
            }.bind(this)});
        } else {
            TweenMax.to(this._snakeContainer, 0.2, {y: (this._snakeContainer.y - (5 * status)), x: (this._snakeContainer.width / 2), onComplete: function() {
                this._snakeX = -this._snakeX;
            }.bind(this)});
        }
    }

    @autobind
    private _noteAnimation(note: PIXI.extras.AnimatedSprite, sideClicked: string) {
        let sideShow = -1;
        if (sideClicked === "right") { sideShow = 1; }
        TweenMax.fromTo(note, 0.6, {alpha: 1, x: (this._screenWidth / 2) + (sideShow * 50), y: this._snakeVaseContainer.y - 50}, {alpha: 0, x: (this._screenWidth / 2) + (sideShow * 90), y: this._snakeVaseContainer.y - 100});
    }

    private createButton(name: string) : PIXI.Container{
        var button = new PIXI.Container();
        button.addChild(this._drawRect(this._screenWidth, this._screenHeight, 0x617a72, 1));  
        button.alpha = 0; 
        button.name = name;
        button.x = (name === "left") ? 0 : this._screenWidth;
        button.y = 0;
        button.interactive = true;
        button.buttonMode = true;
        button.on(Poussepython.CLICK, this._onClick, this);
        button.on(Poussepython.TAP, this._onClick, this);
        return button;  
    }

    private _drawRect(w: number = this._screenWidth, h: number = this._screenHeight, color: number = 0xFFFFFF, alpha: number = 1) {
        let rect = new PIXI.Graphics;
        rect.beginFill(color, alpha);
        rect.drawRect(0, 0, w, h);
        rect.endFill();
        return rect;
    };

    /*
     * @core override
     * _start - Starts the game
     *  
     */
    protected _start() {
        super._start();        

        TweenMax.fromTo(this._instructionContainer, 0.3, {alpha: 0}, {alpha: 1});

        Assets.sounds['python'].play();
    };

    /*
     * @core override
     * _onTimerComplete - on game timer complete handler
     * @param {event} e - Event
     * 
     */
    protected _onTimerComplete(e) {
        super._onTimerComplete(e);
        window.removeEventListener('keydown', this._onKeyPress);    
    };


    protected _end() {
        super._end();
        Assets.sounds['python'].stop();
    }

    /*
     * @core override
     * _resize - Resize handler
     * @param {event} e - Event
     * 
     */
    protected _resize(e?: Event) {
        super._resize(e);

        if (this._gameMode === GameMode.PLAYING || typeof e === 'undefined') {
            this._instructionContainer.x = (this._screenWidth - this._instructionContainer.width) / 2;
            this._instructionContainer.y = (this._screenHeight - this._instructionContainer.height) / 4;

            this._snakeVaseContainer.x = ((this._screenWidth - this._snakeVaseContainer.width) / 2);
            this._snakeVaseContainer.y = this._screenHeight - this._vase.height - 50;

            this._snakeContainer.x = this._snakeContainer.width / 2;
            this._snakeContainer.y = this._vase.y - 50;

            this._snakeFace.scale.x = 0.5;
            this._snakeFace.scale.y = 0.5;
            this._snakeFace.rotation = 358;

            this._snakeFace.x = this._snakeFace.width - 2;
            this._snakeFace.y = 8;

            this._mask.height = this._screenHeight - this._vase.height;

            this._ruler.x = (this._screenWidth - this._ruler.width) / 2;
            this._ruler.height = this._screenHeight;
            
            this._note.y = this._failNote.y = this._snakeVaseContainer.y - 60;
            
            // Resetting buttons width and height
            (this._buttonLeft.getChildAt(0) as PIXI.Graphics).height = this._screenHeight;
            (this._buttonLeft.getChildAt(0) as PIXI.Graphics).width = this._screenWidth/2;
            (this._buttonRight.getChildAt(0) as PIXI.Graphics).height = this._screenHeight;
            (this._buttonRight.getChildAt(0) as PIXI.Graphics).width = this._screenWidth/2;
            this._buttonRight.x = this._screenWidth/2;
        }
    };

}